import React, { useState, useEffect } from 'react';
import StyledButton from '../../app/components/styledComponents/StyledButton';
import { useSelector } from 'react-redux';

const InstallPWAButton = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isInstallable, setIsInstallable] = useState(false);
  const [isInstalled, setIsInstalled] = useState(false);
  const floristData = useSelector((state) => state.auth.account);
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    // Check if the app is running as standalone (installed PWA)
    const checkIfInstalled = () => {
      const isStandalone =
        window.matchMedia('(display-mode: standalone)').matches ||
        window.navigator.standalone;
      setIsInstalled(isStandalone);
      return isStandalone;
    };

    // Listen for the beforeinstallprompt event (Android)
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setIsInstallable(true);
    };

    // Initial check for installation and platform
    const isInstalledCheck = checkIfInstalled();
    const userAgent = window.navigator.userAgent.toLowerCase();
    const isIOSDevice = /iphone|ipad|ipod/.test(userAgent);
    setIsIOS(isIOSDevice);

    // Show install button for iOS if not installed
    if (isIOSDevice && !isInstalledCheck) {
      setIsInstallable(true);
    }

    // Android installation event listener
    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    // Track installation status changes
    window.addEventListener('appinstalled', () => {
      setIsInstalled(true);
    });

    const mediaQuery = window.matchMedia('(display-mode: standalone)');
    const handleMediaChange = (e) => setIsInstalled(e.matches);
    mediaQuery.addEventListener('change', handleMediaChange);

    // Cleanup
    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
      mediaQuery.removeEventListener('change', handleMediaChange);
    };
  }, []);

  const handleInstallClick = async () => {
    if (isIOS) {
      // iOS installation instructions
      alert('To install this app:\n1. Tap the Share button\n2. Select "Add to Home Screen"');
      return;
    }

    // Android installation
    if (deferredPrompt) {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      console.log(`User response: ${outcome}`);
      setDeferredPrompt(null);
      setIsInstallable(false);
    }
  };

  if (isInstalled) return null;

  return (
    <>
      {isInstallable && (
        <StyledButton
          id="installButton"
          onClick={handleInstallClick}
          style={{
            display: 'block',
            position: 'fixed',
            bottom: '20px',
            right: '20px',
            borderRadius: '150px',
            zIndex: 9999,
          }}
        >
          Install {floristData?.floristDTO?.companyName} as an App
        </StyledButton>
      )}
    </>
  );
};

export default InstallPWAButton;